import svgIcon from './index.vue'

export default {
    install(Vue) {
      Vue.component(svgIcon.name, svgIcon)
    }
  }
